module.exports = "/_next/static/resources/gotr-wide-e5a2599aacca00880999977b7baebe59.png";